import { createFileRoute } from '@tanstack/react-router'

import { meQueryOptions } from '@/shared/auth/hooks/useGetMe'
import { HodSitesPage } from '@/systems/issues/features/hod-inbox/components/HodSitesPage'
import { hodSitesQueryOptions } from '@/systems/issues/features/hod-inbox/hooks/useHodSites'

// HOD's site directory. Sites grouped under each owned department, with
// dept-level attention items + filter/sort/search per dept. Replaces the
// older /hod/departments route (renamed 2026-05-12 per PM feedback —
// the page is sites-led, dept is a grouping concept now).
//
// Parent /hod route role-gates to hod, so no extra beforeLoad needed.
export const Route = createFileRoute('/hod/sites/')({
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(meQueryOptions())
    void queryClient.prefetchQuery(hodSitesQueryOptions())
  },
  component: HodSitesPage,
})
